import {Entity} from "./Entity";

export class Bateau extends Entity {
    cap_max: number;
}
